import {
  List,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  ShowButton,
  FunctionField,
  Button,
} from "react-admin";
import type { RaRecord } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import DownloadIcon from "@mui/icons-material/Download";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useRouteId } from "@/utils/route-utility";
import { openProjectTakhmeenReceiptPrint } from "./project-takhmeen-receipt-utils";

export const ProjectTakhmeenReceiptList = () => {
  const projectId = useRouteId();
  if (!projectId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Open a project from the Projects list to view receipts.
        </Typography>
      </Box>
    );
  }
  return (
    <List perPage={25} sort={{ field: "receiptDate", order: "DESC" }} filter={{ projectId }}>
      <Datagrid rowClick="show">
        <TextField source="receiptNo" emptyText="—" />
        <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
        <TextField source="paymentMode" />
        <DisplayDateField source="receiptDate" />
        <FunctionField
          label="Print"
          render={(rec: RaRecord) => (
            <Button
              label="Print"
              onClick={(e) => {
                e.stopPropagation();
                openProjectTakhmeenReceiptPrint(rec.id);
              }}
            >
              <DownloadIcon />
            </Button>
          )}
        />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};
